module.exports = "<?xml version=\"1.0\" encoding=\"UTF-8\" standalone=\"no\"?> <svg width=426px height=424px viewBox=\"0 0 426 424\" version=1.1 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink> <polygon points=\"240.96939 318.352074 386.726749 172.594715 425.617622 211.485588 213.485588 423.617622 212.778481 422.910515 212.071374 423.617622 -0.0606601718 211.485588 38.8302128 172.594715 185.96939 319.733892 185.96939 0.0606601718 240.96939 0.0606601718 240.96939 318.352074\"></polygon> </svg>";


//////////////////
// WEBPACK FOOTER
// ./assets/images/icons/arrow-down.svg
// module id = 272
// module chunks = 0